export const ICONOS_LOGRO_ANTIGUOS = {
  estrella: '⭐',
  fuego: '🔥',
  copa: '🏆',
  manos: '🤝',
  pelota: '🎾',
  rayo: '⚡',
  corona: '👑',
  sonrisa: '😄',
} as const;

/** Convierte los nombres guardados por la primera versión a su emoji visible. */
export function emojiDeLogro(icono: string): string {
  return ICONOS_LOGRO_ANTIGUOS[icono as keyof typeof ICONOS_LOGRO_ANTIGUOS] ?? icono;
}

/** Acepta una sola secuencia emoji, incluidas banderas, tonos y familias ZWJ. */
export function esEmojiUnico(valor: unknown): valor is string {
  if (typeof valor !== 'string' || !valor || valor !== valor.trim() || valor.length > 32) return false;
  if (!/[\p{Extended_Pictographic}\p{Regional_Indicator}\u20e3]/u.test(valor)) return false;
  return [...new Intl.Segmenter('es', { granularity: 'grapheme' }).segment(valor)].length === 1;
}
